import React, { Component } from 'react';
import { Form, Input, Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';

class LargeProjectOrderEntry_options extends Component {
    constructor(props) {
        super(props);
        this.state = {
            optionValue: ''
        }
    }

    
    handleDropDownChanges = (value) => { 
        console.log('value:', JSON.stringify(value,null,3));
        console.log('details:', value.value + " " + value.category);

        let newState = {};

        newState['optionValue'] = value.value;

        this.setState(newState);

        this.props.handleLargeProjectEntryDropDownChanges(value);
    }

    render() {

        return (
            <div>
                <Label pointing='below' color='blue'>{this.props.option.option_name}</Label>
                <Select
                    name="form-field-name"
                    value={this.state.optionValue}
                    //value={'medium'}
                    //options={this.state.shirtSizesSele}
                    options={this.props.option.option_selections}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
            </div>);
    }
}

export default LargeProjectOrderEntry_options;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/LargeProjectOrderEntry_options.js